// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import preventReClick from './common'
import store from './vuex/store'
import jquery from 'jquery'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './request'

import App from './App';
import router from './router';

import { pcaa } from 'area-data-vue';
import 'area-linkage-vue/dist/index.css';
import AreaLinkageVue from 'area-linkage-vue';
import VueLazyload from 'vue-lazyload'

Vue.prototype.$pcaa = pcaa;

Vue.use(AreaLinkageVue)

Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.prototype.baseURL = process.env.API_ROOT
Vue.prototype.antdiyURL = process.env.ANTDIY_API_ROOT
Vue.prototype.baseURL2 = process.env.API_ROOT_AD
Vue.prototype.antStoreURL = process.env.ANTSTORE_API
Vue.prototype.aliService = process.env.ALI_SERVICE
Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.use(VueLazyload)
Vue.use(VueLazyload, {
  lazyComponent: true
})

let setPower = function(list, url, routerUrl) {
    let isSure = false
    for (let i = 0; i < list.length; i++) {
        if ((routerUrl && list[i].route == routerUrl) || !routerUrl) {
            if (list[i].route == url) {
                isSure = true
                break
            } else if (list[i].children && list[i].children.length) {
                isSure = setPower(list[i].children, url)
                if (isSure == true) {
                    break
                }
            }
        }
    }
    return isSure
}

Vue.prototype.$getPower = function(arr, routerUrl) {
    if (localStorage.getItem('root_id') == '0' || localStorage.getItem('as_tag') == '2') {
        return arr.map(str => {
            return true
        })
    }
    let menuList = localStorage.getItem('menuList') ? JSON.parse(localStorage.getItem('menuList')) : []
    if (menuList.length) {
        return arr.map(str => {
            return setPower(menuList, str, routerUrl)
        })
    } else {
        return arr.map(str => {
            return false
        })
    }
}

var vue = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js